




















import { Component, Vue } from "vue-property-decorator";
import NewsItem from "@/components/NewsItem.vue";
import request from "@/api/jiangjin/index";
import native from "@/common/Native";
import { Loading, List } from "vant";
import AppPrompt from "@/components/AppPrompt.vue";
import { ISpecialDetail, IInfoThemeDetails } from "@/api/wanzhou/types";
import { Base64 } from "js-base64";
@Component({
  components: {
    NewsItem,
    [Loading.name]: Loading,
    [List.name]: List,
    AppPrompt
  }
})
export default class SpecialList extends Vue {
  newsList: Array<ISpecialDetail> = [];
  public request = new request();
  infoThemeId: string = "";
  infoThemeName: string = "";
  infoClassifyId: string = "";
  newsLoaded: boolean = false;
  private listLoading: boolean = false;
  private finished: boolean = false;
  public appId: string = "";

  mounted() {
    this.infoClassifyId = this.$route.query.id
      ? (this.$route.query.id as string)
      : (this.$route.query.cid as string) || "2435342";
    this.infoThemeId = this.$route.query.infoThemeId as string; // 分类id
    this.infoThemeName = this.$route.query.infoThemeName as string; // 分类id
    this.appId = (this.$route.query.appId as string) || "";
    this.getInfoThemeList();

    document.title = this.infoThemeName;
  }

  getInfoThemeList() {
    let lastId: string = "",
      sortNoValue: string = "",
      onlineTimeValue: string = "";
    if (this.newsList.length > 0) {
      let lastItem = this.newsList[this.newsList.length - 1];
      lastId = String(lastItem["id"]);
      sortNoValue = String(lastItem["sortNo"]);
      onlineTimeValue = String(lastItem["onlineTime"]);
    }
    this.newsLoaded = true;
    this.request
      .getTopicChildlList(
        this.infoClassifyId,
        this.infoThemeId,
        this.appId,
        lastId,
        sortNoValue,
        onlineTimeValue
      )
      .then(result => {
        this.newsLoaded = false;
        if (result.code == 0) {
          if (result.data.dataList.length < 10) {
            this.finished = true;
          }
          result.data.dataList.forEach((item: any) => {
            if (item.images) {
              item.imgList = (item.images as string).split(";");
            } else {
              item.imgList = [];
            }
          });
          this.newsList = this.newsList.concat(result.data.dataList);
        }
        this.listLoading = false;
      })
      .finally(() => {
        this.listLoading = false;
      });
  }
  onListLoad() {
    if (this.newsList.length == 0) {
      return;
    }
    // console.log("scroll loading");
    this.getInfoThemeList();
  }
  //跳转热点详情
  newItemClick(item: any) {
    if (native.isOpenInApp()) {
      native.openWebBrowser({
        id: item.id,
        sourceId: item.informationId,
        detailViewType: item.detailViewType,
        sourceType: item.sourceType,
        commentType: item.commentType,
        contextType: item.contextType,
        isShowTop: "1",
        isShowBottom: "1",
        isShowMore: "1",
        url: item.url,
        shareUrl: item.shareUrl,
        title: Base64.encode(item.title), //base 64
        synopsis: Base64.encode(item.synopsis), //base 64
        shareImgUrl: item.shareImgUrl,
        videoFormat: item.videoFormat ? item.videoFormat : ""
      });
    } else {
      // 分享出去 外链新闻增加浏览量的操作（因为无法在详情中增加浏览量）
      if (item.sourceType == 1) {
        // 外链
        this.request.getCount(this.appId, item.id);
      }
      window.location.href = item.url;
    }
  }
}
